<template>
    <div
        class="w-11/12 px-6 my-2 -ml-4 bg-blue-100 border-l-4 border-blue-500 md:w-5/5 rounded-r-md"
    >
        <div class="flex items-center py-4">
            <!-- <i class="text-4xl text-gray-700 fill-current fas fa-info-circle"></i> -->
            <div class="ml-5">
                <h1 class="text-lg font-bold">Message de Succès</h1>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style></style>
